import Constant from '@/const';
import axios from 'axios';

const getNoOrder = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/supportservice/laboratory/code'),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getNoOrder;
